<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="MEDICINA PREPAGADA" key="1">
        <g-master name="evaluators"
                  @params="paramsTable"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :beforeSend="master.beforeSend"
                  modalWidth="60%"
                  @action="masterAction"
                  ref="master"
                  :actions="master.actions"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='INACTIVO' ? 'red' : (text === 'ACTIVO' ? 'blue' : 'blue')">{{text}}</a-tag>
          </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados_en_reqliquidacion"
                          ref="empleado"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="prep_healthplan"
                            style="width: 100%"
                            :label="$t('Plan medicina prepagada')"
                            :formItemConfig="fiOptions"
                            :params="{health_plan_filter: true}"
                            :decorator="['id_prep_healthplan', { rules: [{ required: true, message: 'Valor requerido'}] }]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Tipo de beneficiario')"
                            :formItemConfig="fiOptions"
                            :selectedObj.sync="objTipoBeneficiario"
                            :params="{h_lookup_type: 'BENEFICIARIO_MEDPREPAGADA'}"
                            :decorator="['id_h_bene_type', { rules: [{ required: true, message: 'Valor requerido'}] }]">
                </g-dropdown>
              </a-col>

              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Beneficiario')"
                          :formItemConfig="fiOptions"
                          :disabled="isRequiredBenf"
                          endpoint="personfamily"
                          ref="beneficiario"
                          :decorator="['id_person_bene', { rules: [{ required: isVisibleBenf, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Cotizante')"
                            :formItemConfig="fiOptions"
                            :params="cotiza"
                            :decorator="['contribuitor', { rules: [{ required: false, message: 'Valor requerido'}], initialValue: 'S' }]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Estado')"
                            :formItemConfig="fiOptions"
                            :params="estado"
                            :decorator="['status', { rules: [{ required: true, message: 'Valor requerido'}], initialValue: 'ACT' }]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha inicio certificado')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['start_certificate', { rules: [{ required: false, message: 'Valor requerido' }, { validator: validateDate }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha fin certificado')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['end_certificate', { rules: [{ required: false, message: 'Valor requerido' }, { validator: validateDate }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        fecha_inicial: null,
        fecha_final: null,
        isRequiredBenf: true,
        objTipoBeneficiario: {},
        isVisibleBenf: false,
        tipoEntidadSeleccionada: {},
        colOptions: {xs: 24, sm: 8},
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        cotiza: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        master: {
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'},
                fnVisible: () => !this.$userIsInrol('Query')
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'},
                fnVisible: () => !this.$userIsInrol('Query')
              }
            ]
          },
          endpoint: 'emp_prep_health',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id_prep_health'
            },
            columns: [
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_completo', sorter: true},
              {title: 'Plan med. prepagada', dataIndex: 'prep_healthplan', sorter: true},
              {title: 'Tipo de beneficiario', dataIndex: 'h_bene_type', sorter: true},
              {title: 'Beneficiario', dataIndex: 'person_family_name', sorter: true},
              {title: 'Fecha inicio certificado', dataIndex: 'inicio_certificado', sorter: true},
              {title: 'Fecha fin certificado', dataIndex: 'fin_certificado', sorter: true},
              {title: 'Cotizante', dataIndex: 'contribuidor', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'contribuitor'},
            {name: 'end_certificate'},
            {name: 'h_bene_type'},
            {name: 'id_emp'},
            {name: 'id_h_bene_type'},
            {name: 'id_person_bene'},
            {name: 'id_prep_healthplan'},
            {name: 'prep_healthplan'},
            {name: 'start_certificate'},
            {name: 'status'}
          ]
        },
        endpointExcel: 'emp_prep_health_/downloadExcel',
        fileNameExcel: 'MedicinaPrepagada',
        paramsT: {}
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
              if (!JsUtils.isEmpty(action.record.id_person_bene)) {
                this.$refs.beneficiario && this.$refs.beneficiario.handleSearch(action.record.id_person_bene)
              }
            })
            if (action.record.h_bene_type === 'EMPLEADO') {
              this.isVisibleBenf = false
              this.isRequiredBenf = true
              this.$refs.master.modal.form.setFieldsValue({
                id_person_bene: null
              })
            } else {
              this.isVisibleBenf = true
              this.isRequiredBenf = false
            }
            this.fecha_inicial = new Date(action.record.start_certificate)
            this.fecha_final = new Date(action.record.end_certificate)
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(this.objTipoBeneficiario) && this.objTipoBeneficiario.text === 'EMPLEADO') {
              this.isVisibleBenf = false
              this.isRequiredBenf = true
              this.$refs.master.modal.form.setFieldsValue({
                id_person_bene: null
              })
            } else {
              this.isVisibleBenf = true
              this.isRequiredBenf = false
            }

            if (!JsUtils.isEmpty(action.changedFields.start_certificate)) {
              this.fecha_inicial = new Date(action.changedFields.start_certificate.value)
            }

            if (!JsUtils.isEmpty(action.changedFields.end_certificate)) {
              this.fecha_final = new Date(action.changedFields.end_certificate.value)
            }
            break
          case 'masterCreate':
            let fecha_actual = new Date()
            fecha_actual = fecha_actual.getFullYear() + '-' + (fecha_actual.getMonth() + 1) + '-' + fecha_actual.getDate()
            this.fecha_inicial = fecha_actual
            this.$refs.master.modal.form.setFieldsValue({
              start_certificate: fecha_actual
            })
            this.isVisibleBenf = false
            this.isRequiredBenf = true
            break
        }
      },
      validateDate (rule, value, callbackFn) {
        if (this.fecha_inicial > this.fecha_final) {
          callbackFn('La fecha inicial no puede ser mayor a la final')
          return false
        } else {
          return true
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/EmpPrepHealth.vue